import { SelectOption } from 'global';

import { ActivityListFilters } from './types';

export const initialFilters: ActivityListFilters = {
  search: '',
  callFilters: {
    callStatus: [],
    callDirection: [],
  },
};

export const callDirectionOptions: SelectOption[] = [
  { value: 'INCOMING', label: 'Incoming' },
  { value: 'OUTGOING', label: 'Outgoing' },
];

export const callStatusOptions: SelectOption[] = [
  { value: 'ANSWERED', label: 'Answered' },
  { value: 'UNANSWERED', label: 'Unanswered' },
];

export const DEFAULT_ACTIVITY_LIST_LIMIT = 50;

export const MESSAGES_AVATAR_COLORS = ['#E1BEE7', '#BBDEFB', '#B2DFDB', '#FFE0B2', '#F8BBD0', '#C8E6C9'];
